/**
 * URL-key slug transform: strips disallowed characters, collapses
 * whitespace/dashes, lowercases. Used by `useQueryParam` to derive the
 * lookup key from a user-supplied `name`/`property`, and by any caller
 * (e.g. the SSR prefetch loaders) that needs to compute the same URL key
 * `useStoredFilters` reads.
 */
export const slugify = (name: string): string =>
  name
    // remove not allowed characters
    .replace(/[^\w\s$*_+~()'"!\-:@]/g, '')
    // trim leading/trailing spaces
    .trim()
    // convert spaces
    .replace(/[-\s]+/g, '-')
    .toLowerCase()
